/*
 * @Author: SuperficialL
 * @Date: 2021-04-27 19:01:13
 * @LastEditTime: 2021-08-19 14:47:49
 * @Description: 请求库封装
 */
import axios from "axios";
import {
    Message
} from "element-ui";
import common from "@comm/utils/common";
import {
    getToken
} from "@comm/utils/auth";
import uaParser from "ua-parser-js";
const ua = uaParser(navigator.userAgent);
const APIPort = process.env.APIPort

// 创建axios实例
const service = axios.create({
    baseURL: common.apiUrl,
    // withCredentials: true, // 跨域请求时发送cookie
    timeout: 180000 // 请求超时
});

// if (process.env.NODE_ENV == 'development') {
//   localStorage.setItem('vue_admin_template_token', 'cdc912033ade0eda26f33adc32b83b56dd69f4ca4f8371b3625e89bf20d46dc0')
// }

// 请求拦截器
service.interceptors.request.use(
    config => {
        config.headers["token"] = getToken();
        // config.headers['Content-Type'] = 'application/json'
        return config;
    },
    error => {
        // do something with request error
        // for debug
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    // 通过自定义代码确定请求状态，可以通过HTTP状态代码判断状态
    response => {
        const res = response.data;
        if (
            res.code &&
            res.code !== 0 &&
            res.code !== 70002 &&
            res.code !== 20010 &&
            res.code !== 30006 &&
            res.code !== 50001 &&
            res.code !== 100016 &&
            res.code !== 30011 &&
            res.code !== 30012 &&
            res.code !== '00000' &&
            res.code !== 'A0005' &&
            res.code !== 'A0007' &&
            res.code !== 110001
        ) {
            Message.closeAll();
            console.log(456,res.code)
            Message({
                message: res.msg || "请检查网络",
                type: "error",
                duration: 5 * 1000
            });
            return Promise.reject(res);
        } else if (!res.data && !res.code && !res.msg) {
            return response;
        } else {
            return res;
        }
    },
    error => {
        if (error && error.response && error.response.status == 401) {
            let nickname =localStorage.nickname
            sessionStorage.clear();
            localStorage.clear();
            if (APIPort == 8001) {
                let path = document.location.pathname
                localStorage.setItem('nickname',nickname)
                window.open(
                    `https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
                    "_self"
                );
            }
            // if (APIPort == 8014) {
            //     window.open(`${common.localLoginUrl}`, "_self");
            // }
        } else if (
            error.code == "ECONNABORTED" &&
            error.message.indexOf("timeout") != -1 &&
            !error.config._retry
        ) {
            return Promise.reject(error);
        } else {
            // 处理iphone设备跳转报错问题
            if (ua.device.vendor != "Apple") {
                Message.closeAll();
                console.log(123,error)
                Message({
                    message: "请检查网络",
                    type: "error",
                    duration: 5 * 1000
                });
            }
            //  location.reload();
        }
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/comm/utils/request.js